export default {
	"order.ExchangeSuccessfully": "兑换成功",
	"order.NoActivationAddress": "无激活地址！"
}